export const CHECKOUT_URL = 'https://clinical.impultienda.ar/checkout/renal'

export const MOCKUP_IMAGE =
  'https://cdn.magicpatterns.com/uploads/2WtWNs2UBEuGgzP9HKs8j4/FERTILIDAD-4.png'

export const DOCTOR_IMAGE =
  'https://cdn.magicpatterns.com/patterns/generated-images/648d2eb9-5209-4c60-856f-868176116a66.jpg'

export const stats = [
  { value: '+300', label: 'Páginas clínicas' },
  { value: '6', label: 'Tomos especializados' },
  { value: '5', label: 'Bonos premium' },
  { value: '3 min', label: 'Por algoritmo' },
  { value: '+1.000', label: 'Médicos' },
]

export const beforeItems = [
  'Pasas más tiempo buscando respuestas que atendiendo al paciente.',
  'Abres KDIGO, UpToDate y múltiples guías… y aun así terminas con dudas.',
  'No sabes si esa caída de la TFG es realmente preocupante o puede esperar.',
  'Suspendes medicamentos por miedo, aunque podrían estar protegiendo el riñón.',
  'Derivas pacientes “por si acaso”, sin certeza de que realmente lo necesiten.',
  'Sales del consultorio pensando: “Espero haber tomado la decisión correcta.”',
]

export const afterItems = [
  'Abres el algoritmo correcto y sigues una única ruta clínica.',
  'Identificas el estadio renal en minutos, sin ambigüedades.',
  'Sabes exactamente qué pedir y qué interpretar.',
  'Sabes qué iniciar, qué mantener y qué suspender.',
  'Sabes qué controlar y cada cuánto volver a citar.',
  'Sabes con certeza cuándo derivar… y cuándo no hace falta.',
]

export const pains = [
  {
    emoji: '😰',
    title: 'Ves una creatinina elevada',
    text: 'Y no sabes si estás frente a una urgencia o un hallazgo que puede esperar. Temes subestimar a un paciente que está perdiendo función renal o sobretratar un resultado aislado.',
  },
  {
    emoji: '⏱️',
    title: 'Lo que debería tomar minutos consume media consulta',
    text: 'Saltas entre diferentes guías buscando una respuesta práctica mientras el paciente espera una decisión.',
  },
  {
    emoji: '💊',
    title: 'Cada fármaco genera una nueva duda',
    text: 'Miedo de suspender un medicamento que protege el riñón… o de mantener uno que podría perjudicar. IECA. ARA II. Metformina. iSGLT2.',
  },
  {
    emoji: '⚠️',
    title: 'Un potasio elevado cambia toda tu consulta',
    text: 'No sabes si puedes manejarlo de forma ambulatoria o si el paciente necesita ser enviado inmediatamente a emergencias.',
  },
  {
    emoji: '📉',
    title: 'No tienes claro cuándo hay progresión real',
    text: 'Cada nuevo laboratorio parece abrir más preguntas que respuestas.',
  },
  {
    emoji: '😔',
    title: 'El paciente se va, la duda se queda',
    text: 'Te preguntas durante horas si realmente tomaste la mejor decisión para ese riñón.',
  },
]

export const tomos = [
  {
    emoji: '📘',
    tomo: 'Tomo I',
    title: 'El Radar Renal™',
    lead: 'Detecta la enfermedad renal antes de que todos la pasen por alto.',
    text: 'Convierte cualquier alteración de creatinina o TFG en un diagnóstico claro y una estadificación precisa mediante algoritmos visuales fáciles de aplicar.',
  },
  {
    emoji: '📗',
    tomo: 'Tomo II',
    title: 'El Escudo Nefroprotector™',
    lead: 'Protege la función renal sin suspender los medicamentos que salvan riñones.',
    text: 'Aprende exactamente cuándo iniciar, mantener, ajustar o suspender IECAs, ARA II e iSGLT2 con absoluta seguridad clínica.',
  },
  {
    emoji: '📙',
    tomo: 'Tomo III',
    title: 'El Controlador del Medio Interno™',
    lead: 'Domina el potasio, los diuréticos y el equilibrio ácido-base.',
    text: 'Resuelve las alteraciones metabólicas más frecuentes siguiendo protocolos simples y listos para aplicar, sin volver a paralizarte en consulta.',
  },
  {
    emoji: '📕',
    tomo: 'Tomo IV',
    title: 'El Triángulo Cardio-Renal-Metabólico™',
    lead: 'Maneja la comorbilidad crítica sin decisiones contradictorias.',
    text: 'Diabetes, hipertensión, insuficiencia cardíaca y riñón en un solo plan terapéutico coherente, con prioridades claras en cada escenario.',
  },
  {
    emoji: '📓',
    tomo: 'Tomo V',
    title: 'El Filtro Maestro™',
    lead: 'Consulta rápida para el seguimiento del paciente renal.',
    text: 'Anemia, fósforo, calcio, vitamina D, acidosis y criterios de progresión: qué medir, cuándo medirlo y qué hacer con cada resultado.',
  },
  {
    emoji: '📔',
    tomo: 'Tomo VI',
    title: 'Herramientas y Checklists Clínicos™',
    lead: 'Todo el sistema convertido en hojas de acción imprimibles.',
    text: 'Criterios de derivación, plantillas de consulta, escalas y verificadores para que ninguna decisión importante quede fuera de la historia clínica.',
  },
]

export const deliverables = [
  {
    emoji: '📘',
    title: 'Los 6 Tomos Premium de Ruta Enfermedad Renal™',
    text: 'No son libros para leer de principio a fin. Son herramientas clínicas para decidir en minutos. Cada tomo resuelve una parte crítica del manejo renal: desde el diagnóstico inicial hasta la monitorización a largo plazo.',
  },
  {
    emoji: '🧭',
    title: 'Algoritmos Clínicos de Decisión™',
    text: 'Olvídate de interpretar cientos de páginas de guías. Cada algoritmo responde una única pregunta: “Cuando veo esto… ¿qué hago ahora?” Paso a paso. Sin dudas.',
  },
  {
    emoji: '🛡️',
    title: 'Protocolos de Nefroprotección™',
    text: 'Aprende cuándo proteger el riñón… y cuándo un cambio de creatinina no significa que debas suspender un tratamiento. Cada protocolo reduce la incertidumbre clínica.',
  },
  {
    emoji: '⚡',
    title: 'Rutas de Acción Inmediata™',
    text: 'Cuando el laboratorio llegue alterado, no abrirás tres guías distintas. Solo seguirás la ruta: diagnóstico, tratamiento, monitorización y derivación, en el orden correcto.',
  },
  {
    emoji: '📋',
    title: 'Checklists Inteligentes™',
    text: 'Cada consulta tendrá un proceso claro: qué preguntar, qué pedir, qué interpretar, qué indicar, qué controlar y cuándo volver a citar al paciente.',
  },
]

export const bonuses = [
  {
    tag: 'Bono #1',
    title: 'Protocolo Hiperkalemia Zero™',
    image:
      'https://cdn.magicpatterns.com/uploads/kSwE4FGFo5T6R8vSunNFcC/BONO_1_RENAL.png',
    lead: 'Nunca más vuelvas a paralizarte frente a un potasio elevado.',
    bullets: [
      'Cuándo observar.',
      'Cuándo tratar.',
      'Cuándo ajustar medicamentos.',
      'Cuándo derivar inmediatamente.',
    ],
    value: 'USD 37',
  },
  {
    tag: 'Bono #2',
    title: 'Vademécum Renal Inteligente™',
    image:
      'https://cdn.magicpatterns.com/uploads/6bWgwhctdjnAnG8RLVWDSt/BONO_2_RENAL.png',
    lead: 'Los 100 medicamentos que más usas con el ajuste exacto según función renal.',
    bullets: [
      'Antibióticos y antidiabéticos.',
      'Anticoagulantes y analgésicos.',
      'Antihipertensivos y más.',
      'Organizado para consulta rápida.',
    ],
    value: 'USD 47',
  },
  {
    tag: 'Bono #3',
    title: 'Scripts de Consulta Renal™',
    image:
      'https://cdn.magicpatterns.com/uploads/a9UefEL9yHrJXPiEC9yuxc/BONO_3_RENAL.png',
    lead: 'Las respuestas exactas para las preguntas más difíciles de tus pacientes.',
    bullets: [
      'Qué decir.',
      'Cómo decirlo.',
      'Cómo transmitir tranquilidad.',
      'Explicaciones claras y sencillas.',
    ],
    value: 'USD 27',
  },
  {
    tag: 'Bono #4',
    title: 'Los 25 Errores Críticos™',
    image:
      'https://cdn.magicpatterns.com/uploads/v8PJZ6oNKF3GCQc5DtSZRi/BONO_4_RENAL.png',
    lead: 'Las equivocaciones que aceleran la pérdida de la función renal.',
    bullets: [
      'Errores que retrasan el tratamiento.',
      'Errores que empeoran el pronóstico.',
      'Fallos frecuentes incluso en expertos.',
      'Cómo evitarlos desde hoy.',
    ],
    value: 'USD 47',
  },
  {
    tag: 'Bono #5',
    title: 'Checklist Maestro de la Consulta Renal™',
    image:
      'https://cdn.magicpatterns.com/uploads/sVp4WnpTJ2CUsrcGts5LiC/BONO_5_RENAL.png',
    lead: 'Nunca más olvides un laboratorio, una indicación o un criterio importante.',
    bullets: [
      'Sistema imprimible.',
      'Consulta ordenada y rápida.',
      'Nada queda fuera.',
      'Listo para tu próximo paciente.',
    ],
    value: 'USD 37',
  },
]

export const valueRows = [
  { label: 'Ruta Enfermedad Renal™ (6 Tomos Premium)', value: 'USD 97' },
  { label: 'Protocolo Hiperkalemia Zero™', value: 'USD 37' },
  { label: 'Vademécum Renal Inteligente™', value: 'USD 47' },
  { label: 'Scripts de Consulta Renal™', value: 'USD 27' },
  { label: 'Los 25 Errores Críticos™', value: 'USD 47' },
  { label: 'Checklist Maestro™', value: 'USD 37' },
]

export const testimonials = [
  {
    quote:
      'Antes derivaba pacientes por inseguridad. Hoy sé exactamente cuáles puedo manejar y cuándo realmente necesitan un nefrólogo.',
    name: 'Dr. Ricardo M.',
    country: 'México 🇲🇽',
    photo:
      'https://cdn.magicpatterns.com/patterns/generated-images/78975b95-7236-4ee8-9cf0-3356eb4c158f.jpg',
  },
  {
    quote:
      'Solo el Escudo Nefroprotector™ cambió mi forma de prescribir. Dejé de suspender tratamientos por miedo y empecé a proteger mejor la función renal.',
    name: 'Dra. Elena L.',
    country: 'Colombia 🇨🇴',
    photo:
      'https://cdn.magicpatterns.com/patterns/generated-images/9b81df95-cdfb-44d6-b6cb-96591d6c8e3a.jpg',
  },
  {
    quote:
      'El Vademécum Renal Inteligente™ permanece abierto durante todas mis consultas. Me ahorra muchísimo tiempo.',
    name: 'Dr. Esteban P.',
    country: 'España 🇪🇸',
    photo:
      'https://cdn.magicpatterns.com/patterns/generated-images/7e776683-ccbb-4ea4-88ef-8ed131200181.jpg',
  },
  {
    quote:
      'Los Scripts de Consulta me ayudaron a explicar la enfermedad renal con mucha más seguridad. Los pacientes entienden mejor su diagnóstico.',
    name: 'Dra. Mariana V.',
    country: 'Argentina 🇦🇷',
    photo:
      'https://cdn.magicpatterns.com/patterns/generated-images/60c4f2df-94d4-4b33-8112-3524fabb59cf.jpg',
  },
]

export const faqs = [
  {
    q: '¿Cómo recibo el material?',
    a: 'Inmediatamente después del pago recibirás el acceso para descargar todos los tomos y bonos. En pocos minutos podrás comenzar a utilizarlos.',
  },
  {
    q: '¿Funciona en cualquier país?',
    a: 'Sí. Todo el contenido está basado en guías internacionales (KDIGO y otras recomendaciones ampliamente aceptadas), por lo que puede aplicarse en cualquier contexto clínico hispanohablante.',
  },
  {
    q: '¿Los archivos son descargables?',
    a: 'Sí. Todos los materiales están en formato PDF de alta calidad para leerlos desde tu computadora, tablet o celular, e imprimirlos si lo deseas.',
  },
  {
    q: '¿Es un pago único?',
    a: 'Sí. Pagas una sola vez y el acceso será tuyo para siempre. Sin mensualidades ni costos ocultos.',
  },
  {
    q: '¿Necesito ser nefrólogo?',
    a: 'No. Ruta Enfermedad Renal™ fue diseñada para médicos generales, internistas, residentes y profesionales que atienden pacientes con enfermedad renal en la práctica diaria y necesitan decidir con mayor seguridad.',
  },
  {
    q: '¿En qué moneda pago?',
    a: 'El checkout detecta tu país y realiza el cambio de moneda automáticamente. Pagarás el equivalente a USD 15 en tu moneda local.',
  },
]

export const buyers = [
  { name: 'Dr. Andrés G.', city: 'Bogotá', country: 'Colombia' },
  { name: 'Dra. Lucía F.', city: 'Buenos Aires', country: 'Argentina' },
  { name: 'Dr. Miguel S.', city: 'Ciudad de México', country: 'México' },
  { name: 'Dra. Paula R.', city: 'Lima', country: 'Perú' },
  { name: 'Dr. Javier T.', city: 'Madrid', country: 'España' },
  { name: 'Dra. Camila O.', city: 'Santiago', country: 'Chile' },
  { name: 'Dr. Fernando A.', city: 'Quito', country: 'Ecuador' },
  { name: 'Dra. Valeria N.', city: 'Montevideo', country: 'Uruguay' },
  { name: 'Dr. Héctor L.', city: 'Guatemala', country: 'Guatemala' },
  { name: 'Dra. Rosa M.', city: 'San José', country: 'Costa Rica' },
  { name: 'Dr. Iván P.', city: 'Caracas', country: 'Venezuela' },
  { name: 'Dra. Daniela C.', city: 'Asunción', country: 'Paraguay' },
]
